import HttpHelpers from './helpers';

const PaymentsApiEndpoints = {
  getBookingPayment: (id) => {
    return HttpHelpers.authenticatedAxios
      .get(`booking-payment/${id}`)
      .then((response) => response.data);
  },
};

export default PaymentsApiEndpoints;
